<template >
  <v-app style="background: rgba(0,0,0,0);">
    <v-container >
      <v-layout align-center grid-list-md text-xs-center>
          <v-flex xs12 sm10 md8 lg8 class="main" style="margin:0 auto">
		  	<div class="title"><h1>OXFORD PERSÖNLICHKEITSTEST</h1></div>

				<v-card color="primary">
				<v-card-title primary-title class="justify-center ma-5 maintitle">
				<div class="display-1 font-weight-bold white--text">Die Nachricht wurde erfolgreich versandt!</div>
				</v-card-title>
				</v-card>

	            <v-card class="contentwrap">
				<h3>WICHTIGE INFORMATION</strong></h3>
                <p>Die Schritte für die Auswertung sind die folgenden:</p>
                <h3>Vorbereitung</h3>
                <p>Wir werden Sie unter der angegebenen Telefonnummer kontaktieren um einen pers&ouml;nlichen Termin mit Ihnen abzustimmen.</p>
                <p>Sie bestimmen eine passende Zeit wann Sie zur Testauswertung kommen k&ouml;nnen.</p>
                <h3>Testauswertung</h3>
                <p>Sobald Sie erscheinen wird Sie unser professioneller Testauswerter begr&uuml;ssen und Ihnen die Ergebnisse Ihres Test wissen lassen.</p>
				<img src="https://ocatestcenter.de/oca-test-beispiel-big.png" style="width: 100%; height: auto; margin-top:15px; margin-bottom:30px;">
                <h3>Pers&ouml;nliche Beratung</h3>
                <p>Dieser Test misst Ihre 10 maßgeblichen Charaktereigenschaften und zeigt diejenigen Abweichungen in Ihrer Persönlichkeit auf, die Sie im Leben am meisten behindern.</p>
                <p>Ihr pers&ouml;nlicher Berater wird Ihnen bez&uuml;glich der Testergebnisse Vorschl&auml;ge unterbreiten wie Sie die nicht optimalen Punkte des Tests in Ordnung bringen oder verbessern k&ouml;nnen.</p>
                <h3>Dieser Service ist v&ouml;llig kostenlos!</h3>
                <p>Danach haben Sie die M&ouml;glichkeit diejenigen B&uuml;cher im Buchladen zu erhalten, die Ihnen helfen werden die verschiedenen Teile in Ihrem Leben besser zu organisieren. Sie k&ouml;nnen sich aber auch in einen empfohlenen Lebensverbesserungskurs einschreiben.</p>
                <p>Danke f&uuml;r Ihre Aufmerksamkeit!</p>
                <p><strong>Unsere Adresse lautet:</strong> Heilbronner Strasse 69, 70191-Stuttgart -Mitte (gegen&uuml;ber&nbsp;Milaneo)</p>
				<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2628.45608072297!2d9.17877521567206!3d48.79227347928105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4799db29570aa6f7%3A0xc103608849b99b68!2sHeilbronner+Str.+69%2C+70191+Stuttgart%2C+N%C3%A9metorsz%C3%A1g!5e0!3m2!1shu!2shu!4v1560897062770!5m2!1sde!2sde" width="100%" height="400" frameborder="0" style="border:0" allowfullscreen></iframe>
              </v-card>

          </v-flex>
      </v-layout>
    </v-container>
    <div class="logo"></div>

    <MyFooter/>
  </v-app>
</template>

<script type="text/javascript">
import MyFooter from '../components/footer.vue'
export default {
  components: {
    MyFooter
  }
}
</script>

<style media="screen">
body {
  background-image: url(background.png);
  background-position: right top;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.container {
    display: table;
}
.logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
	background-image: url(oca-logo.png);
	background-repeat: no-repeat;
	max-width: 250px;
  background-size: contain;
  margin-top: 10px;
  margin-left: 1.5%;
  height: 200px;
  width: 19vw;
}
.introsection2 {
	padding-top: 30px;
    margin-top: 30px;
    padding-left: 50px;
    padding-right: 50px;
    background: #f7f7f7;
}
.ctasection {
    padding: 15px;
}
.v-card {
  overflow:auto;
}
.v-card__title--primary {
    padding-top: 0px;
    padding-bottom: 0px;
}
.v-card__actions {
    padding: 0px;
    background: #fff;
	margin-top: 0px!important;
}
.v-card__actions .xs4 {
    flex-basis: 33.34%!important;
	max-width: 33.34%!important;
}
.v-card__actions .v-sheet {
    border-radius: 0px;
	-webkit-box-shadow: none;
    box-shadow: none;
    text-decoration: none;
}
.yesBtn:hover{
  background-color: rgb(205, 242, 202);
  cursor: pointer;
}
.maybeBtn:hover{
  background-color: rgb(208, 208, 208);
  cursor: pointer;
}
.noBtn:hover{
  background-color: rgb(255, 191, 177);
  cursor: pointer;
}
.main {
    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.15);
    padding: 0;
}
.main .v-sheet {
	border-radius:0px;
}
.title {
    font-size: 20px!important;
	line-height: 50px!important;
    text-align: left!important;
    padding-left: 20px;
	padding-right: 20px;
    background: #fff;
    font-weight: 400;
}
.title h1 {
    font-size: 20px!important;
	line-height: 50px!important;
    text-align: left!important;
    padding-left: 20px;
	padding-right: 20px;
    background: #fff;
    font-weight: 400;
}
.v-card__text {
    padding: 0;
    line-height: 50px;
}
.progress {
    border-radius: 0 0 0 15px;
	padding: 4px 30px 4px 35px;
    background: #006c9f;
    font-size: 15px!important;
    font-weight: 400!important;
}
.contentwrap {
	padding:40px;
	text-align:left;
}
.contentwrap strong {
	font-weight:600;
}
.contentwrap h3 {
	margin-bottom:15px;
}
.maintitle {
    margin: 25px 25px!important;
}
</style>
